/**
 * 项目默认配置项
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * isShowMultiTab - 是否显示横向标签页
 *
 */
export default {
  name: '淮南数字化诊断服务平台',
  tokenKey: 'COMPANY_TOKEN',
  title: '淮南数字化诊断服务平台',
  footerText: '淮南数字化诊断服务平台 © 2024 https://www.myone.cc',
  defaultLocale: 'zh-CN',
  ACCESS_TOKEN: 'company_token',
  ACCESS_TOKEN_TIMEOUT: 'company_token_timeout',
  COMPANY_INFO: 'PMS_COMPANY_INFO',
  DEFAULT_TIMEOUT: 42900, // # 43200 12小时 7200 2小时, 减去300秒 2小时 前端过期时间比后端少 前端过期后 任然有操作的 将向后端刷新token
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  apiBasePath: process.env.VUE_APP_API_BASE_URL,
  preffix: process.env.VUE_APP_APIS_HOST || '', // '/api' 
  WHITE_LIST: ['login', 'logout','register', 'registerResult'],// 访问白名单
  DEFAULT_INDEX: '/index', // 默认首页
  isShowMultiTab: false,
  ACCEPT_CONFIG: { // 文件上传类型支持
    image: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg'],
    audio: ['ogg', 'mp3', 'mav', 'flac', 'aac'],
    video: ['mp4', 'rmvb', 'mov', 'mkv', 'wmv', 'flv'],
    document: ['docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'], // 'doc', , 'wps', 'tif', 'tiff','rar','zip'
    getAll() {
      return [...this.image, ...this.audio, ...this.video, ...this.document]
    },
  },
  BusinessStatusEnums: {
    0 : {name: '禁用', class: 'volcano', color: 'volcano'},
    1 : {name: '暂存', class: 'info', color: 'primary'},
    2 : {name: '待核', class: 'warning', color: 'warning'},
    3 : {name: '退回', class: 'red', color: 'red'},
    4 : {name: '驳回', class: 'error', color: 'error'},
    9 : {name: '有效', class: 'success', color: 'success'},
  },
}